<template>
  <div :key="page_key" class="page-wallet">
    <FrameHeader/>

    <div class="block-papa">

      <!--  -->
      <div class="block-user boxed py-1" style="min-height: 120px;">
        <CpBlockProfile :cfg="{
          auto_call_login: true,
          address_custom: addrfrom,
        }"/>
      </div>
      
      <div class="boxed">
        <div class="ui-tabset style-solid">
          <span 
            v-for="item of head_tabs"
            :key="item.id"
            @click="setHeadTab(item.id)"
            :class="['tab size-big',{'on': on_head_tab == item.id}]"
          >
            {{lg('',item.name)}}
          </span>
        </div>
        <hr class="mb-0">
      </div>

      <!-- my_collection liked -->
      <div 
        v-if="on_head_tab === 'my_collection' || on_head_tab === 'liked'" 
        class="block-cards boxed"
        >
        
        <!-- 隐藏 -->
        <div v-if="0" class="part-left pt-4">

          <filterSet 
            :data_ui="data_filter_set"
            :form="filter_set" 
            class="pl-2"
          />
        </div>

        <div class="part-right">

          <div class="mt-4 pt-2 d-flex">
            <CpBtnSortList 
              class="ml-auto"
              v-model="on_filter"
            />
          </div>

          <div class="pb-5">
            <div class="list-main-prod">
              
              <div v-if="!status_ajaxing_list && list_cards.length === 0" class="text-dark tac p-5 w-100">
                {{lg('',{
                  en: 'Empty',
                  zh: '钱包里面还没有NFT可以展示哟',
                })}}
              </div>

              <div class="item mb-4" v-for="(item,index) of list_cards" :key="index">
                <CpCardProd 
                  :data="item"
                  :cfg="{
                    is_card_checkable: (on_head_tab == 'my_collection' && !addrfrom),
                  }"
                />
              </div>
            </div>
          </div>

          <div style="height: 20px;">
            <div v-if="status_ajaxing_list" class="t-gray tac">
              Loading... 
            </div>
            <CpLoadOnScroll 
              :fn_load_data="autoGetData"
              :status_no_more_data="card__status_no_more_data"
            />
          </div>

          <div class="btn-box-wrap">
            <div v-if="item.name" class="btn-box d-flex flex-wrap">

              <span v-if="status_loading_meta_item" class="ui-loading-icon size-sm">
                <!--  -->
              </span>

              <!-- btn hidden： -->
              <span v-else-if="0 && !status_show_btn_sell && !status_show_btn_buy && !status_show_btn_cancel" class="c">
                {{lg('',{
                  en: 'Currently not for sale',
                  zh: '暂时是非卖品',
                })}}
              </span>

              <!-- btn hidden： -->
              <button v-if="0 && status_show_btn_cancel && !status_doing_cancel" @click="btnCancelSell()" :disabled="status_doing_cancel" class="btn btn-primary uppercase btn-round" style="min-width: 130px;">
                {{lg('',{
                  en: 'Cancel Sell',
                  zh: '取消卖出',
                })}}
              </button>

              <!-- btn hidden： -->
              <button v-if="0 && status_show_btn_buy" @click="btnToggleBuy()" class="btn btn-primary uppercase btn-round" style="min-width: 130px;">
                {{lg('',{
                  en: 'Buy Now',
                  zh: '购买',
                })}}
              </button>

              <button v-if="status_show_btn_sell" @click="btnToggleSell()" class="btn btn-primary uppercase btn-round" style="min-width: 80px;">
                {{lg('sell')}}
              </button>

              <button v-if="status_show_btn_sell || status_show_btn_cancel" @click="btnToggleTransfer()" class="btn btn-primary uppercase btn-round ml-3" style="min-width: 80px;">
                {{lg('',{
                  en: 'Transfer',
                  zh: '转移',
                })}}
              </button>

              <button v-if="status_show_btn_sell || status_show_btn_cancel" @click="closeBtnBox()" class="btn btn-outline-primary uppercase btn-round ml-3" style="min-width: 80px;">
                {{lg('',{
                  en: 'Cancel',
                  zh: '取消',
                })}}
              </button>
            </div>
          </div>
        </div>


      </div>

      <!-- activity -->
      <div 
        v-if="on_head_tab === 'activity'" 
        class="block-history boxed">
        
        <BlockHistory 
          :list_history="list_history" 
          class="px-4"
        />

        <div class="mt-4" style="height: 20px;">
          <div v-if="status_loading_history" class="t-gray tac">
            Loading... 
          </div>
          <CpLoadOnScroll
            :fn_load_data="autoGetData"
            :status_no_more_data="history__status_no_more_data"
          />
        </div>
      </div>
    </div>

    <FrameFooter/>

    <popBuy
      :cfg_status_poppad="cfg_status_poppad_buy"
      :item="item"
      :meta_item="meta_item"
    />

    <popSell
      :cfg_status_poppad="cfg_status_poppad_sell"
      :item="item"
      :meta_item="meta_item"
    />

    <CpPopupTransfer
      :cfg_status_poppad="cfg_status_poppad_transfer"
      :item="item"
      :meta_item="meta_item"
    />
  </div>
</template>

<script>
import bus from '@/bus.js'
import home_tabs from '../home/home_tabs.js'
import filterSet from '../home/filter_set.vue'
import data_filter_set from './data_filter_set_gallery.js'

import BlockHistory from '../wallet/blockHistory.vue'

import popSell from '../detail/pop_sell.vue'
import popBuy from '../detail/pop_buy.vue'


let data_filter_set_keys = data_filter_set.map(item => item.id)
let init_filter_keys = {}
data_filter_set_keys.forEach(function(item){
  init_filter_keys[item] = ''
})

export default {
  name: 'gallery',
  components: {
    BlockHistory,
    filterSet,

    popSell,
    popBuy,
  },
  props: [],
  data() {
    return {

      page_key: 0,
      
      // tab - nft types
      on_home_tab: 'all',
      home_tabs: home_tabs,

      on_filter: '',
      status_ajaxing_list: false,
      list_cards: [],

      // scroll load
      card__next_page_num: 1,
      card__status_no_more_data: false,

      // tab - new mixed nav tab
      on_head_tab: 'my_collection',
      head_tabs: [
        {
          id: "my_collection",
          name: {
            en: "My Collection",
            zh: "我的收藏"
          }
        },
        {
          id: "liked",
          name: {
            en: "Liked",
            zh: "点赞作品"
          }
        },
        {
          id: "activity",
          name: {
            en: "Activity",
            zh: "交易记录"
          }
        },
      ],
      list_history: [],
      status_loading_history: false,

      // scroll load
      history__next_page_num: 1,
      history__status_no_more_data: false,

      // left filter
      data_filter_set: data_filter_set,
      filter_set: init_filter_keys,

      // popup
      cfg_status_poppad_transfer: false,
      cfg_status_poppad_buy: false,
      cfg_status_poppad_sell: false,
      item: {},
      meta_item: {},
      status_show_btn_cancel: false,
      status_show_btn_buy: false,
      status_show_btn_sell: false,
      status_loading_meta_item: false,
      status_doing_cancel: false,


      // 
      account_wallet: this.$store.state.web3.account_wallet,

      // url param addrfrom
      addrfrom: '',
      gallery_cfg: {
        onshow_user: {},
      },

    }
  },
  computed: {
    all_tab_for_watch(){
      let v = this
      let mark = ''
      mark = v.on_head_tab + v.on_filter
      return mark
    },
  },
  watch: {
    '$route.query.addrfrom'(){
      this.run()
      this.page_key += 1
    },
    '$store.state.web3.account'(val){
      if(val){
        this.run()
      }
    },
    on_filter(){
      this.getTabData()
    },
    filter_set: {
      deep: true,
      handler(){
        this.cleanCheckedItem()
        this.getTabData()
      },
    },

    all_tab_for_watch(){
      this.cleanCheckedItem()
    },
  },
  methods: {

    closeBtnBox(){
      let v = this
      
      // uncheck others
      for(let i in v.$children){
        let child = v.$children[i]
        if(child.item && child.item_meme && child.status_checked){
          child.status_checked = false
        }
      }

      v.cleanCheckedItem()
    },

    btnToggleTransfer(val){
      let v = this

      v.cfg_status_poppad_transfer = val!==undefined ? val : !v.cfg_status_poppad_transfer
    },

    btnToggleBuy(val){
      let v = this

      // check wallet balance
      let token_type = v.meta_item.sell_info.currency
      let price = v.meta_item.sell_info.buyValue * 1.02
      let balance = v.$store.state.web3.account_wallet.find(item => item.id === token_type) || {}
      balance = balance.num
      if(price > balance){
        bus.appvue.showPopupAddFund({
          token_type: token_type,
          nft_name: v.item.name,
        })
        return
      }

      v.cfg_status_poppad_buy = val!==undefined ? val : !v.cfg_status_poppad_buy
    },

    btnToggleSell(val){
      let v = this

      v.cfg_status_poppad_sell = val!==undefined ? val : !v.cfg_status_poppad_sell
    },

    async btnCancelSell(){
      return
      let v = this

      var order = v.meta_item['sell_info']

      let obj = {
        address: v.$store.state.web3.account,
        address_owner: order.address,
        token_address: order.nft_address,
        token_id: order.nft_id,
        salt: order.salt,
        signature: order.signature,
        buyValue: order.buyValue,
        currency: order.currency,
        type: v.meta_item.type,
        callback: function(){
          setTimeout(function(){
            v.status_doing_cancel = false
            v.run()
          },1000)
        },
        callbackOnErr: function(){
          v.status_doing_cancel = false
        }
      }

      v.status_doing_cancel = true
      await v.cancelSell(obj)
    },

    cleanCheckedItem(){
      let v = this
      v.item = {}
      v.meta_item = {}
      v.status_show_btn_sell = false
      v.status_show_btn_buy = false
      v.status_show_btn_cancel = false
      v.status_doing_cancel = false
    },
    async onCheckedItem(meta_item,item){
      let v = this

      v.cleanCheckedItem()

      v.item = item
      await v.api('query_item_detail',{
        'address': v.$store.state.web3.account || '',
        'nft_address': meta_item.nft_address,
        'nft_id': meta_item.nft_id,
        'owner': meta_item.owner_info.address,
      },{
        vue: v,
        key_data: 'meta_item',
        key_ajaxing: 'status_loading_meta_item',
      })

      v.uniCalcItemBuySellBtnStatus(v.meta_item,v)
    },

    async getHistory(){
      let v = this

      await v.uniGetCurrentBlockNum()

      let res = await v.api('list_my_history',{
        'page_num': v.history__next_page_num,
        address: v.$store.state.web3.account,
      },{
        vue: v,
        key_ajaxing: 'status_loading_history',
        // key_data: 'list_history',
      })

      if(res && res.data && res.data.length){
        v.list_history = v.list_history.concat(res.data)
        v.history__next_page_num += 1
      }else{
        v.history__status_no_more_data = true
      }

    },

    shareGallery(){
      let v = this
      let u_name = v.$store.state.user.local_user.username || v.$store.state.user.local_user.address
      let href = window.location.href
      bus.appvue.showPopupShareItem({
        share_link: `${href}${href.indexOf('?')>0?'&':'?'}addrfrom=${v.$store.state.user.local_user.address}`,
        // share_title: `${u_name}'s profile. #BSC #JGNdefi #Collectible #NFT #JGNNFT`,
        share_title: `Check out this awesome NFT from JuggerWOLD! ${u_name}'s profile. #BSC #JGNDeFi #Collectible #NFT #JGNNFT $JGN `,
        pad_title: v.lg('share_this_gallery')
      })
    },

    setHeadTab(str){
      let v = this

      v.on_head_tab = str

      console.log(str)

      v.$router.replace({
        query: {
          tab: str,
          addrfrom: v.addrfrom,
        }
      })

      for(let key in v.filter_set){
        v.filter_set[key] = ''
      }

      v.on_filter = ''

      v.resetGetListFrom()
      v.autoGetData()

      
    },
    setHomeTab(str){
      let v = this
      this.on_home_tab = str

      this.getTabData()
    },

    resetGetListFrom(){
      let v = this
      this.card__next_page_num = 1
      this.card__status_no_more_data = false
      this.list_cards = []

      this.history__next_page_num = 1
      this.history__status_no_more_data = false
      this.list_history = []
    },

    autoGetData(){
      let v = this

      if(v.on_head_tab == 'activity'){
        this.getHistory()
      }
      
      else if(
        v.on_head_tab == 'my_collection' ||
        v.on_head_tab == 'liked' 
      ){
        this.getTabData()
      }
    },

    async getTabData(){
      let v = this

      let query_address =  v.addrfrom || v.$store.state.web3.account

      if(!query_address){
        return
      }

      if(v.status_ajaxing_list){
        return
      }

      let api_str = ''
      let json = {
        'category': v.on_home_tab,
        'filter': v.on_filter,
        'filter_more': v.filter_set,
        'address': query_address,
        'page_num': v.card__next_page_num,
      }
      
      if(v.on_head_tab === 'my_collection'){
        api_str = 'list_asset_my'
      }
      else if(v.on_head_tab === 'liked'){
        api_str = 'list_asset_my_like'
      }
      if(!api_str){
        return
      }
      // v.list_cards = []
      let res = await v.api(api_str,json,{
        vue: v,
        key_ajaxing: 'status_ajaxing_list',
      })
      // if(res.code === 0){
      //   v.list_cards = res.data
      // }

      if(res && res.data && res.data.length){
        v.list_cards = v.list_cards.concat(res.data)
        v.card__next_page_num += 1
      }else{
        v.card__status_no_more_data = true
      }
      v.status_ajaxing_list = false
    },

    run(){
      if(this.$route.query.tab){
        this.on_head_tab = this.$route.query.tab
      }

      // if(this.$route.query.type){
      //   this.on_home_tab = this.$route.query.type
      // }

      if(this.$route.query.addrfrom){
        this.addrfrom = this.$route.query.addrfrom
      }else{
        this.addrfrom = ''
      }

      this.cleanCheckedItem()
      this.autoGetData()
    },
  },
  created() {
    this.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .block-cards{

    .part-right{
      position: relative;

      .btn-box-wrap{
        $h: 80px;

        margin-top: 10px;
        height: $h;
        position: sticky;
        bottom: 0;

        .btn-box{
          height: $h;
          display: flex;
          align-items: center;
          width: 100%;
          background-color: rgba(240,240,240,0.95);
          text-align: center;
          padding: 10px;
          justify-content: center;
        }
      }

    }
  }

  @media(min-width: 788px){

    .block-cards{
      display: flex;

      .part-left{
        width: 300px;
        border-right: 1px solid $c_border;
        padding-right: 30px;
      }
      .part-right{
        flex: 1;
      }
    }
  }
  @media(max-width: 788px){
    .block-cards{

      .part-left{
        
      }
      .part-right{
        .list-main-prod{
          padding-top: 50px;
        }
      }
    }
  }
</style>